import { useState } from "react";
import { formatGal, formatToEighths, productName } from "@/lib/tank";
import { useT } from "@/lib/i18n";

export function SaveSiteModal({ s, sites, onCancel, onSave }) {
  const t = useT();
  const [mode, setMode] = useState("new");
  const [name, setName] = useState("");
  const [siteId, setSiteId] = useState(sites[0]?.id ?? null);
  const [label, setLabel] = useState("Tank 1");
  const valid = label.trim() && (mode === "new" ? name.trim() : siteId);
  const save = () => valid && onSave({ mode, name: name.trim(), siteId, label: label.trim() });

  return (
    <div className="modal-backdrop" data-testid="save-site-modal" onClick={onCancel}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="section-title">{t("Save this tank")}</div>
        <p className="sub">
          {formatGal(s.capacity)} gal · {s.diameter}" {t(productName(s.product))} · {t("stick")} {formatToEighths(s.startInches)}
        </p>
        {sites.length > 0 && (
          <div className="seg">
            <button type="button" className={mode === "new" ? "seg-on" : ""} data-testid="save-mode-new" onClick={() => setMode("new")}>{t("New site")}</button>
            <button type="button" className={mode === "add" ? "seg-on" : ""} data-testid="save-mode-add" onClick={() => setMode("add")}>{t("Add to a site")}</button>
          </div>
        )}
        {mode === "new" ? (
          <input className="text-input" data-testid="site-name-input" autoFocus placeholder={t("Station name")}
            enterKeyHint="next" autoComplete="off" maxLength={80} value={name} onChange={(e) => setName(e.target.value)} />
        ) : (
          <div className="site-pick" data-testid="site-pick-list">
            {sites.map((x) => (
              <button key={x.id} type="button" data-testid={`site-pick-${x.id}`}
                className={`site-pick-item ${siteId === x.id ? "site-pick-on" : ""}`} onClick={() => setSiteId(x.id)}>
                <span>{x.name}</span><span className="card-sub">{(x.tanks.length === 1 ? t("1 tank") : t("{n} tanks", { n: x.tanks.length }))}</span>
              </button>
            ))}
          </div>
        )}
        <label className="field"><span className="label">{t("Tank label")}</span>
          <input className="text-input" data-testid="tank-label-input" placeholder={t("e.g. T1 Regular")} enterKeyHint="done"
            autoComplete="off" maxLength={40} value={label} onChange={(e) => setLabel(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && save()} />
        </label>
        <div className="modal-actions">
          <button type="button" className="ghost-btn" data-testid="site-save-cancel" onClick={onCancel}>{t("Cancel")}</button>
          <button type="button" className="primary-btn" data-testid="site-save-confirm" disabled={!valid} onClick={save}>{t("Save")}</button>
        </div>
      </div>
    </div>
  );
}
